import { Box, Typography, useTheme } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useTranslation } from "react-i18next";
import { PricingPlanPeriod } from "../../../shared/types/pricingPlanTypes";
import { useStyles } from "../styles/PeriodSelector.styles";

interface PeriodSelectorProps {
  selectedPeriod: PricingPlanPeriod;
  onPeriodChange: (period: PricingPlanPeriod) => void;
}

const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  selectedPeriod,
  onPeriodChange,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <Box className={classes.buttonsContainer}>
        <Box
          className={classes.leftButton}
          style={{
            backgroundColor:
              selectedPeriod === "month"
                ? theme.palette.main.secondary.o
                : theme.palette.natural.t7,
          }}
          onClick={() => onPeriodChange("month")}
        >
          <Typography
            style={{
              fontSize: 16,
              fontWeight: selectedPeriod === "month" ? "700" : "500",
              color:
                selectedPeriod === "month"
                  ? theme.palette.natural.t4
                  : theme.palette.natural.t2,
            }}
          >
            {t("subscriptions.tarifs.monthly")}
          </Typography>
        </Box>
        <Box
          className={classes.rightButton}
          style={{
            backgroundColor:
              selectedPeriod === "year"
                ? theme.palette.main.secondary.o
                : theme.palette.natural.t7,
          }}
          onClick={() => onPeriodChange("year")}
        >
          <Typography
            style={{
              fontSize: 16,
              fontWeight: selectedPeriod === "year" ? "700" : "500",
              color:
                selectedPeriod === "year"
                  ? theme.palette.natural.t4
                  : theme.palette.natural.t2,
            }}
          >
            {t("subscriptions.tarifs.yearly")}
          </Typography>
        </Box>
      </Box>
      {selectedPeriod === "year" && (
        <Box className={classes.bonusCard}>
          <Box className={classes.bonusCardIconContainer}>
            <AttachMoneyIcon className={classes.bonusCardIcon} />
          </Box>
          <Typography className={classes.bonusCardText}>
            {t("subscriptions.tarifs.freeMonths")}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PeriodSelector;
